import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

export default function ConclusionEditor({ conclusionHtml, onChange }) {
  const editor = useEditor({
    extensions: [StarterKit],
    content: conclusionHtml || "",
    onUpdate: ({ editor }) => onChange(editor.getHTML()),
  });

  // « Pré-remplir depuis l'autobio » recharge le brouillon sans démonter cet
  // éditeur : sans cette resynchronisation, tiptap garderait le contenu qu'il
  // avait à sa création et la conclusion fraîchement extraite resterait
  // invisible — exactement le symptôme signalé sur le dossier Adeline.
  useEffect(() => {
    if (!editor) return;
    const next = conclusionHtml || "";
    if (next !== editor.getHTML()) {
      editor.commands.setContent(next, { emitUpdate: false });
    }
  }, [editor, conclusionHtml]);

  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Conclusion</strong></legend>
      <p style={{ fontSize: 12, color: "#666", margin: "0 0 8px" }}>
        Le paragraphe de fin (« Ce que je te propose »). Il est repris de l'autobio, sans
        son titre, et s'affiche en bas du mini-site avant la BD complète.
      </p>
      <div
        data-testid="conclusion-editor"
        style={{ minHeight: 100, border: "1px solid #ddd", borderRadius: 4, padding: 8 }}
      >
        <EditorContent editor={editor} />
      </div>
    </fieldset>
  );
}
